import { Routes } from '@angular/router';

export const ORDERS_PATHS = {
  BASE: 'orders',
  TODAY: 'today',
  TOMORROW: 'tomorrow',
  SCHEDULED: 'scheduled',
  READY: 'ready',
  COMPLETED: 'completed'
};

export const OrdersRoutes: Routes = [
  {
    path: '',
    loadComponent: () => import('@core/layout/main-layout/main-layout').then((m) => m.MainLayout),
    children: [
      {
        path: '',
        redirectTo: ORDERS_PATHS.TODAY,
        pathMatch: 'full'
      },
      {
        path: ':timeframe',
        loadComponent: () => import('./pages/orders/orders.page').then((m) => m.OrdersPage)
      }
    ]
  }
];
